import { AxiosRequestConfig } from "axios";
import { Report } from "../Interfaces/TableInterfaces";
import { IChartWithNameResponse } from "../Interfaces/chartInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import {
  IAdjustmentTablesSearchParam,
  IDailyReferenceGraphDTO,
  IHourlyPortfoValueGraphDTO,
} from "../Interfaces/deltaHedgeAdjustment";
import { DropdownItem } from "../Interfaces/dropdownInterfaces";
import {
  INLegOrderbooksResp,
  INLegsAddOrderFormValues,
} from "../Interfaces/nLegsInterfaces";
import {
  IGetOrdersDTO,
  IGetRiskFreeRateResp,
  IGroupAddEditDTO,
  IGroupTableReport,
  IOptionDomainChartsReport,
  IOptionDomainFormValues,
  IOptionDomainLiveWatchListSearchParam,
  IOptionDomainOrderbooksBody,
  IOptionDomainPortfoWatchListSearchParam,
  IOptionDomainSearchParam,
  IOptionDomainSearchParams,
  IOptionDomainTableReport,
  IPairPositionChartSearchParams,
  IPairPositionReport,
  IPairPositionSearchParams,
  IWhiteListTableReport,
  IPairPositionFilterSearchParams,
} from "../Interfaces/optionDomain";
import { Graph_Dto } from "../Interfaces/orderbookGraphInterfaces";
import {
  deleteRequest,
  getRequest,
  getTable,
  postDownloadExcel,
  postRequest,
  putRequest,
} from "./requestTemplates";

export const getOptionDomainExceptionsDropdowns = (): Promise<DropdownItem[]> =>
  getRequest("/v1/OptionDomain/GetExceptionalDropdown");

export const getRemainingOptionId = (): Promise<DropdownItem[]> =>
  getRequest("/v1/OptionDomain/RemainingOptions");

export const setOptionDomainExceptions = (
  exceptions: any[],
): Promise<Packet<boolean>> =>
  postRequest("/v1/OptionDomain/SetExpectionals", exceptions);

export const addOptionDomain = (
  formValues: IOptionDomainFormValues,
): Promise<Packet<boolean>> => postRequest("/v1/OptionDomain/Add", formValues);

export const editOptionDomain = (
  formValues: IOptionDomainFormValues,
): Promise<Packet<boolean>> => putRequest("/v1/OptionDomain/Edit", formValues);

export const getOptionDomainTable = (
  searchParam: IOptionDomainSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IOptionDomainTableReport>> =>
  getTable<IOptionDomainSearchParam, IOptionDomainTableReport>(
    "/v1/OptionDomain/GetTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getGroupTable = (
  _: any,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IGroupTableReport>> =>
  getTable<any, IGroupTableReport>(
    "/v1/OptionDomain/getDeltaHedgeGroupTable",
    {},
    offset,
    pageSize,
    sortingType,
  );

export const getGroups = (): Promise<IGroupAddEditDTO[]> =>
  postRequest("/v1/OptionDomain/getGroups", {});

export const getOptionInstruments = (): Promise<DropdownItem[]> =>
  getRequest("/v1/Step/getInstruments?type=Option");

export const addGroup = (body: IGroupAddEditDTO): Promise<Packet<boolean>> =>
  postRequest("/v1/OptionDomain/addGroup", body);

export const editGroup = (body: IGroupAddEditDTO): Promise<Packet<boolean>> =>
  putRequest("/v1/OptionDomain/editGroup", body);

export const deleteGroup = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/OptionDomain/deleteGroup?id=${id}`);

export const deleteOptionDomain = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/OptionDomain/delete?optionFilterId=${id}`);

export const getBaseInsCalculationsTable = (
  searchParam: IOptionDomainLiveWatchListSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<IOptionDomainLiveWatchListSearchParam, any>(
    "/v1/optionDomain/BaseInstrumentCalculationTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getLiveWatchlistTable = (
  searchParam: IOptionDomainLiveWatchListSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<IOptionDomainLiveWatchListSearchParam, any>(
    "/v1/OptionDomain/GetLiveWatchLists",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getPairPositionTable = (
  searchParam: IPairPositionSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IPairPositionReport>> =>
  getTable<IPairPositionSearchParams, IPairPositionReport>(
    "/v1/OptionDomain/GetLivePairWatchLists",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );
export const getDeltaGammaRefTable = (
  searchParam: IAdjustmentTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<IAdjustmentTablesSearchParam, any>(
    "/v1/DeltaHedgeAdjustment/DeltaGammaRef",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getpairPositionExcel = (
  searchParam: IOptionDomainSearchParams,
) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/OptionDomain/GetLivePairWatchListsExcel?${rand}`,
    searchParam,
  );
};
export const getRiskFreeRate = (): Promise<IGetRiskFreeRateResp> =>
  getRequest("/v1/OptionDomain/getRiskFreeRate");

export const setServerRiskFreeRate = (
  dto: IGetRiskFreeRateResp,
): Promise<Packet<boolean>> =>
  postRequest("/v1/OptionDomain/setRiskFreeRate", dto);

export const getLiveWatchlistExcel = (
  searchParam: IOptionDomainSearchParams,
) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/OptionDomain/getliveexcel?${rand}`,
    searchParam,
  );
};

export const getVolatilityChart = (
  searchParam: IPairPositionChartSearchParams,
): Promise<Report<IOptionDomainChartsReport>> =>
  postRequest(
    "/v1/optionDomain/GetAccountAggeragatedByAccountPortfo/VolatilitySensitivityChart?Offset=0&Pagesize=10000",
    searchParam,
  );
export const getPriceChart = (
  searchParam: IPairPositionChartSearchParams,
): Promise<Report<IOptionDomainChartsReport>> =>
  postRequest(
    "/v1/optionDomain/GetAccountAggeragatedByAccountPortfo/PriceSensitivityChart?Offset=0&Pagesize=10000",
    searchParam,
  );
export const getTimeChart = (
  searchParam: IPairPositionChartSearchParams,
): Promise<Report<IOptionDomainChartsReport>> =>
  postRequest(
    "/v1/optionDomain/GetAccountAggeragatedByAccountPortfo/TimeSensitivityChart?Offset=0&Pagesize=10000",
    searchParam,
  );

export const getOrders = (
  dto: IGetOrdersDTO,
): Promise<INLegsAddOrderFormValues[]> =>
  postRequest("/v1/optionDomain/getorders", dto);

export const getOptionDomainOrderbooks = (
  body: IOptionDomainOrderbooksBody,
): Promise<INLegOrderbooksResp> =>
  postRequest("/v1/OptionDomain/GetOrderBooks", body);

export const getOptionDomainChart = (
  headerName: string,
  insCode1: string,
  insName1: string,
  insCode2: string,
  insName2: string,
  positionType1: string,
  fromDate?: string,
  toDate?: string,
): Promise<Graph_Dto> => {
  const baseUrl = `/v1/OptionDomain/GetChartData?HeaderName=${headerName}&insCode1=${insCode1}&insName1=${insName1}&insCode2=${insCode2}&insName2=${insName2}&positionType1=${positionType1}`;

  return getRequest(
    baseUrl +
      (fromDate ? `&from=${fromDate}` : "") +
      (toDate ? `&to=${toDate}` : ""),
  );
};

export const getDailyReferenceGraphe = (
  dto: IDailyReferenceGraphDTO,
): Promise<Graph_Dto[]> =>
  postRequest("/v1/DeltaHedgeAdjustment/DailyReferenceGraph", dto);

export const getDailyPortfoGraph = (
  dto: IDailyReferenceGraphDTO,
): Promise<Graph_Dto[]> =>
  postRequest("/v1/DeltaHedgeAdjustment/DailyReferenceGraph", dto);

export const getHourlyPortfoValueGraph = (
  dto: IHourlyPortfoValueGraphDTO,
): Promise<Graph_Dto[]> =>
  postRequest("/v1/DeltaHedgeAdjustment/HourlyPortfoValueGraph", dto);

/**
 * DeltaHedge => OptionDomain
 * حدول وایت لیست
 *
 * @param {any} _
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getWhiteListTable = (
  _: any,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IWhiteListTableReport>> =>
  getTable<any, IWhiteListTableReport>(
    "/v1/OptionDomain/whitelisttable",
    {},
    offset,
    pageSize,
    sortingType,
  );

/**
 * Deltahedge => Option Domain => Pair position
 * تنظیمات فیلتر
 *
 * @async
 * @version 1.4.0
 */
export const getFilterSetting = (): Promise<IPairPositionFilterSearchParams> =>
  getRequest("v1/OptionDomain/pairPosition/getpreset");

/**
 * Deltahedge => Option Domain => Pair position
 * ثیت فیلتر
 *
 * @param {IPairPositionFilterSearchParams} config
 * @async
 * @version 1.4.0
 */
export const setFilterSetting = (
  config: IPairPositionFilterSearchParams,
): Promise<Packet<boolean>> =>
  putRequest("v1/OptionDomain/pairPosition/setpreset", config);
